export default "__VITE_ASSET__l53jSD9q__"